var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUseCases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 3.00004H9.66732V1.66671C9.66732 0.926707 9.07398 0.333374 8.33398 0.333374H5.66732C4.92732 0.333374 4.33398 0.926707 4.33398 1.66671V3.00004H1.66732C0.927318 3.00004 0.340651 3.59337 0.340651 4.33337L0.333984 11.6667C0.333984 12.4067 0.927318 13 1.66732 13H12.334C13.074 13 13.6673 12.4067 13.6673 11.6667V4.33337C13.6673 3.59337 13.074 3.00004 12.334 3.00004ZM8.33398 3.00004H5.66732V1.66671H8.33398V3.00004Z",
    fill: "#535A60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCases);
export default __webpack_public_path__ + "static/media/useCases_.a10ba4dccc880b31a3e11e55363c78bc.svg";
export { ForwardRef as ReactComponent };